import { CalendarDate } from "./calendar-date";
export class Reminder {
    constructor() {
        this.id = null;
        this.parentName = "";
        this.parentHref = "";
        this.dueDate = null;
        this.dueDateTime = null;
        this.title = "";
    }
    when() {
        if (this.dueDate) {
            return this.dueDate.dayEnd();
        }
        else if (this.dueDateTime) {
            return this.dueDateTime;
        }
        return null;
    }
    clone() {
        return Reminder.clone(this);
    }
    static clone(source) {
        const theClone = new Reminder();
        theClone.id = source.id;
        theClone.parentName = source.parentName;
        theClone.parentHref = source.parentHref;
        theClone.dueDate = source.dueDate;
        theClone.dueDateTime = source.dueDateTime;
        theClone.title = source.title;
        return theClone;
    }
    static load(source) {
        const theClone = new Reminder();
        theClone.id = source.id;
        theClone.dueDate = source.dueDate
            ? CalendarDate.parse(source.dueDate).getOrElse(null)
            : null;
        theClone.dueDateTime = source.dueDateTime ? new Date(source.dueDateTime) : null;
        theClone.parentName = source.parentName;
        theClone.parentHref = source.parentHref;
        theClone.title = source.title;
        return theClone;
    }
}
//# sourceMappingURL=reminder.js.map